import { Icon } from '@chakra-ui/icons';

export const LinkGrayIcon = ({ color = 'action' }: { color?: string }) => (
	<Icon
		width="16px"
		height="16px"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.824 5.74756H7.52403C6.75083 5.74756 6.12402 6.37436 6.12402 7.14756V13.4476C6.12402 14.2208 6.75083 14.8476 7.52403 14.8476H13.824C14.5972 14.8476 15.224 14.2208 15.224 13.4476V7.14756C15.224 6.37436 14.5972 5.74756 13.824 5.74756Z"
			stroke={color}
			strokeWidth="1.4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3.32413 9.94768H2.62412C2.25282 9.94768 1.89672 9.80018 1.63417 9.53762C1.37162 9.27507 1.22412 8.91898 1.22412 8.54767V2.24766C1.22412 1.87636 1.37162 1.52026 1.63417 1.25771C1.89672 0.995156 2.25282 0.847656 2.62412 0.847656H8.92414C9.29544 0.847656 9.65154 0.995156 9.91409 1.25771C10.1766 1.52026 10.3241 1.87636 10.3241 2.24766V2.94766"
			stroke={color}
			strokeWidth="1.4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</Icon>
);
